export default __webpack_public_path__ + "static/media/airlockz-cbb-1.12823d08.png";